export const ConstantsUtil = {
    ACCOUNT_TABS: [{ label: 'Tokens' }, { label: 'NFTs' }, { label: 'Activity' }]
};
//# sourceMappingURL=ConstantsUtil.js.map